import { ProductType } from 'lane-shared/domains/billingPayments/types';
import { TFunction } from 'i18next';

/**
 * Get the display label for a product type
 */
export const getProductTypeLabel = (
  productType: ProductType,
  t: TFunction
): string => {
  switch (productType) {
    case ProductType.PRODUCT_TYPE_SERVICE_LABOUR:
      return t('abp.charges.addProduct.modal.type.service');
    case ProductType.PRODUCT_TYPE_SERVICE_MATERIALS:
      return t('abp.charges.addProduct.modal.type.product');
    default:
      return '-';
  }
};

